import request from '@/utils/request'
import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'

// 发布运营信息
export function issueInfo(data) {
  return request({
    url: '/bus/operation',
    method: 'POST',
    data
  })
}

// 获取总数
export function getCounts() {
  return request({
    url: '/bus/operation/counts',
    method: 'GET',
  })
}

// 获取运营信息详情
export function getOperationDetail(id) {
  return request({
    url: `/bus/operation/${id}`,
    method: 'GET',
  })
}

export function editOperation(data) {
  return request({
    url: `/bus/operation`,
    method: 'PUT',
    data
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/system/user/getUserInfo',
    method: 'GET',
  })
}

// 获取运营信息
export function getInfo(param) {
  const url = handlerGetUrlParams('/bus/operation/list', param)
  return request({
    url,
    method: 'GET'
  })
}

// 删除运营信息
export function deleteInfo(id) {
  return request({
    url: `/bus/operation/del/${id}`,
    method: 'DELETE'
  })
}

// 审批运营信息
export function statusInfo(data) {
  return request({
    url: '/bus/contents/operation/audit',
    method: 'PUT',
    data
  })
}

// 编辑运营信息
export function editInfo(data) {
  return request({
    url: '/bus/operation',
    method: 'PUT',
    data
  })
}

// 发布和下架运营信息
export function editStatusInfo(data) {
  return request({
    url: '/bus/operation/status',
    method: 'PUT',
    data
  })
}
